import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const RevenueChart = ({ monthlyRevenueByMonth = [] }) => {
  const labels = monthlyRevenueByMonth.map((entry) => entry.month);
  const values = monthlyRevenueByMonth.map((entry) => entry.revenue);

  const data = {
    labels,
    datasets: [
      {
        label: "Umsatz (€)",
        data: values,
        borderColor: "#8884d8",
        backgroundColor: "rgba(136, 132, 216, 0.2)",
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `€${tooltipItem.raw.toLocaleString()}`,
        },
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: { display: true, text: "Monate" },
      },
      y: {
        title: { display: true, text: "Umsatz (€)" },
        beginAtZero: true,
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default RevenueChart;
